export interface MousePosition {
  mouseX: null | number;
  mouseY: null | number;
}

export enum ResourceSourceType {
  Website = 'Website',
  BOOKS = 'Books',
  JOURNALS = 'Journals',
}

export enum AsyncStatusEnum {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  RESOLVE = 'RESOLVE',
  REJECT = 'REJECT',
}

export enum SearchCategories {
  WEB = 'Web',
  PAPER = 'Paper',
  NEWS = 'News',
}

export enum CreateProjectTriggerBy {
  CREATE_NEW = 'create-new',
  UPLOAD = 'upload',
  UPLOAD_ZERO_STATE = 'upload-editor-zero-state',
  NO_PROJECT = 'no-project',
  CLOSE = 'close',
  TEMPLATE_BLOG = 'template-blog',
  TEMPLATE_ESSAY = 'template-essay',
  TEMPLATE_MLA = 'template-MLA',
  TEMPLATE_APA = 'template-APA',
  FILE_MENU = 'file-menu',
}

export enum PasteTriggeredByEnum {
  EDITOR_ZERO_STATE = 'editor-zero-state',
  CONTEXT_MENU = 'context-menu',
  HOTKEY = 'hotkey',
  FILE_MENU = 'file-menu',
}

export enum ScraperType {
  DYNAMIC = 'dynamic',
  STATIC = 'static',
}
